import React, { useState } from "react";
import { Modal, Button } from "semantic-ui-react";

const StartGameModal = ({ startGame }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClose = () => setModalOpen(false);

  const handleOK = () => {
    startGame();
    handleClose();
  };
  return (
    <Modal
      className="keno-modal keno-modal--confirm"
      trigger={
        <img
          src="/static/images/start.svg"
          className="image"
          onClick={() => setModalOpen(true)}
          alt="start"
        />
      }
      open={modalOpen}
      onClose={handleClose}
    >
      <Modal.Header>Commencer le tirage?</Modal.Header>
      <Modal.Content>
        <p>
          Une fois que vous avez commencé le jeu, vous ne pouvez pas revenir en
          arrière.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" className="keno-btn keno-btn--ghost" onClick={handleClose}>
          No
        </Button>
        <Button color="green" className="keno-btn" onClick={handleOK}>
          Yes
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default StartGameModal;
